export const cdnImg = (
  url,
  w = 720,
  h = 'auto',
  fit = 'crop',
  crop = 'center'
) => {
  const encodedUrl = encodeURI(url)
  const parsedUrl = new URL(encodedUrl)

  return `https://cdn-cms.daihatsu.co.id${parsedUrl.pathname}?w=${w}&h=${h}&fit=${fit}&crop=${crop}&auto=format,compress`
}
